import { useMediaQuery, useTheme } from "@mui/material";
import { Box, Divider, Typography } from "@mui/material";
import ACTLogoLight from "../../assets/images/ACT-logo-no-text-dark.png";
import Link from "@mui/material/Link";

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const currentYear = new Date().getFullYear();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.mode === "dark" ? "#1c1c1c" : "#d8d8d8",
        color: theme.palette.text.primary,
        padding: "1.5rem",
        position: "sticky",
        bottom: "0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bottom: isMobile ? "-16rem" : "-10.625rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-end",
          justifyContent: "space-between",
          width: "100%",
          gap: "1.5rem",
          zIndex: "1",
        }}
      >
        <img
          src={ACTLogoLight}
          alt="ACT Logo"
          style={{
            height: "2.5rem",
            marginBottom: "0.2rem",
          }}
        />
      </Box>
      <Divider
        sx={{
          borderBottom: "0.09rem solid #999999",
          marginY: 1.5,
          width: "100%",
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "flex-start" : "flex-end",
          justifyContent: "space-between",
          width: "100%",
          gap: isMobile ? "1rem" : "1.5rem",
          zIndex: "1",
          marginTop: "0.2rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "flex-start",
            gap: isMobile ? "0.5rem" : "0.5rem",
            textAlign: "left",
          }}
        >
          <Typography
            sx={{
              fontWeight: "400",
              fontSize: "0.75rem",
              lineHeight: "1.3",
              color: theme.palette.text.primary,
            }}
          >
            &copy; Copyright {currentYear} Advanced Compliance Technology Ltd
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: isMobile ? "flex-start" : "center",
            justifyContent: "center",
            gap: isMobile ? "0.5rem" : "1.5rem",
          }}
        >
          <Typography
            sx={{
              fontWeight: "400",
              fontSize: "0.75rem",
              textDecoration: "none",
              "&:hover": {
                opacity: "0.6",
              },
            }}
          ></Typography>
          <Typography
            sx={{
              fontWeight: "400",
              fontSize: "0.75rem",
              textDecoration: "none",
              "&:hover": {
                opacity: "0.6",
              },
            }}
          >
            <Link
              href={"https://advancedcompliance.tech/act-verify-terms-of-use/"}
              style={{
                color: theme.palette.text.primary,
                textDecoration: "underline",
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms & Conditions
            </Link>
          </Typography>
          <Typography
            sx={{
              fontWeight: "400",
              fontSize: "0.75rem",
              textDecoration: "none",
              "&:hover": {
                opacity: "0.6",
              },
            }}
          >
            <Link
              href={
                "https://advancedcompliance.tech/act-verify-privacy-policy/"
              }
              style={{
                color: theme.palette.text.primary,
                textDecoration: "underline",
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </Link>
          </Typography>
          <Typography
            sx={{
              fontWeight: "400",
              fontSize: "0.75rem",
              textDecoration: "none",
              "&:hover": {
                opacity: "0.6",
              },
            }}
          >
            <Link
              href={"https://advancedcompliance.tech/"}
              style={{
                color: theme.palette.text.primary,
                textDecoration: "underline",
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Company
            </Link>
          </Typography>
          <Typography
            sx={{
              fontWeight: "400",
              fontSize: "0.75rem",
              textDecoration: "none",
              "&:hover": {
                opacity: "0.6",
              },
            }}
          >
            <Link
              href={"/contact"}
              style={{
                color: theme.palette.text.primary,
                textDecoration: "underline",
              }}
            >
              Contact Us
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
